import React from 'react';
import Editor from 'components/Editor';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Description = () => {
	// Use exam's student store
	const [slug, description] = useExamStudentStore(state => [state.exam.slug, state.exam.description]);

	return (
		<Editor
			readOnly
			path="exams"
			folder={slug}
			value={description}
		/>
	);
};

export default Description;